import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useTheme } from '@emotion/react';
import { useBreakpointDown } from '@travel-frontend/core';
import { useTranslation } from 'next-i18next';
import { ImageGalleryOverlay } from '../../../../components/Image/index.js';
import { CategoryTabs } from '../../../../components/ImageGalleryLayer/components/CategoryTabs/index.js';
import { Button } from '../../../../components/ImageGalleryLayer/components/MainContent/components/Button.js';
import { ButtonContainer } from '../../../../components/ImageGalleryLayer/components/MainContent/components/ButtonContainer.js';
import { Container } from '../../../../components/ImageGalleryLayer/components/OverviewContent/components/Container.js';
import { Content } from '../../../../components/ImageGalleryLayer/components/OverviewContent/components/Content.js';
import { Toolbar } from '../../../../components/ImageGalleryLayer/components/OverviewContent/components/Toolbar.js';
import { useGroupImages } from '../../../../components/ImageGalleryLayer/hooks/useGroupImages.js';
import { priceFormatter } from '../../../../utils/index.js';
export const OverviewContent = ({
  images,
  activeTabIndex,
  onActiveTabIndexChange,
  activeImageIndex,
  onActiveImageIndexChange,
  ctaButton: ctaButtonProperty,
  offerPrice,
  onOfferButtonClick
}) => {
  const {
    t
  } = useTranslation('imageGalleryLayer');
  const mdDown = useBreakpointDown('md');
  const {
    groupedData,
    smallImages
  } = useGroupImages(images, activeTabIndex);
  const theme = useTheme();
  const ctaButtonElement = offerPrice && _jsx(Button, {
    onClick: onOfferButtonClick,
    children: t('offersFrom', {
      value: priceFormatter(offerPrice.locale, offerPrice.currency).format(offerPrice.amount)
    })
  });
  return _jsxs(Container, {
    spacing: 0,
    children: [_jsx(Toolbar, {
      children: _jsx(CategoryTabs, {
        activeTabIndex: activeTabIndex,
        onTabChange: onActiveTabIndexChange,
        backgroundColor: mdDown ? theme.colors.backgroundDark : theme.colors.contentPrimary,
        color: theme.colors.contentInversePrimary,
        groupedData: groupedData,
        ctaButton: ctaButtonProperty,
        offerPrice: offerPrice,
        onOfferButtonClick: onOfferButtonClick,
        isOverview: true
      })
    }), _jsx(Content, {
      children: _jsx(ImageGalleryOverlay, {
        images: smallImages.map(image => image.image_url),
        activeImage: activeImageIndex,
        onSelectImage: onActiveImageIndexChange
      })
    }), mdDown && (ctaButtonProperty || offerPrice) && _jsx(ButtonContainer, {
      children: ctaButtonProperty || ctaButtonElement
    })]
  });
};